import axios from "axios"
import { saveAs } from "file-saver";
import JSZip from "jszip";

export default {
    AuthUsuario() {
        let client_id = "90ad114b-930e-4322-b4aa-bd5e4883dcd0";
        let scope = "files.readwrite.all offline_access";
        let redirect_uri = process.env.VUE_APP_URL_REDIRECTION;

        var credenciales = {
            clientId: client_id,
            scopes: scope,
            redirectUri: redirect_uri,
        }

        let appInfo = Object.assign({}, credenciales);
        appInfo.redirectUri = appInfo.redirectUri.replace(/(#|$)/, '');

        let url = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize" +
            "?client_id=" +
            appInfo.clientId +
            "&scope=" +
            encodeURIComponent(appInfo.scopes) +
            "&response_type=code" +
            "&redirect_uri=" +
            encodeURIComponent(appInfo.redirectUri);

        window.open(url, "_blank").focus();
    },
    async verListaCarpetas(id_usuario, ruta) {
        let credenciales = await this.listarCredencialesOneDrive(id_usuario);

        var response = await axios.post("api/Usuarios/ObtenerNuevoToken", {
            refresh_token: this.getLlave("refresh_token", credenciales).valor,
            redirect_uri: process.env.VUE_APP_URL_REDIRECTION,
        });

        if (credenciales.length > 0) {
            let header = { Authorization: "Bearer " + response.data.access_token, "Content-type": "application/json" };
            let configuracion = { headers: header };

            let result = await axios.get("https://graph.microsoft.com/v1.0/me/drive/root:/" + ruta + ":/children", configuracion)
                .catch((error) => {
                    return error.response
                });

            if (result.status == 404) {
                return result.statusText;
            } else {
                return result.data.value
            }
        }
    },
    async crearArchivo(id_usuario, ruta, archivo) {
        //ruta = "ASEGURADORA/" + "2022/" + "NOVIEMBRE/" + "NUMEROASISTENCIA/"
        let credenciales = await this.listarCredencialesOneDrive(id_usuario);

        var response = await axios.post("api/Usuarios/ObtenerNuevoToken", {
            refresh_token: this.getLlave("refresh_token", credenciales).valor,
            redirect_uri: process.env.VUE_APP_URL_REDIRECTION,
        });

        if (credenciales.length > 0) {
            let header = {
                Authorization: "Bearer " + response.data.access_token,
                'Content-Type': archivo.type
            };
            let configuracion = { headers: header };

            let data = await axios.put("https://graph.microsoft.com/v1.0/me/drive/root:/ASEGURADORAS/" +
                ruta + "/" + archivo.name + ":/content", archivo,
                configuracion
            ).catch((error) => {
                return error.response;
            });

            if (data.status != 200) {
                return result.statusText;
            } else {
                return data;
            }
        }
    },
    async descargarArchivo(id_usuario, items = []) {
        let credenciales = await this.listarCredencialesOneDrive(id_usuario);

        var response = await axios.post("api/Usuarios/ObtenerNuevoToken", {
            refresh_token: this.getLlave("refresh_token", credenciales).valor,
            redirect_uri: process.env.VUE_APP_URL_REDIRECTION,
        });

        let contador = 0;

        if (credenciales.length > 0) {
            let header = { Authorization: "Bearer " + response.data.access_token };
            let zip = new JSZip();

            items.forEach((element) => {
                axios({
                    url: "https://graph.microsoft.com/v1.0/me/drive/items/" + element.id + "/content",
                    responseType: "blob",
                    headers: header
                }).then((response) => {
                    contador++;
                    let blob = new Blob([response.data]);
                    zip.file(element.name, blob);

                    if (contador == items.length) {
                        zip.generateAsync({ type: 'blob' }).then((blob) => {
                            saveAs(blob, "Archivos.zip")
                        })
                    }
                })
            })
        }
    },
    async vistaPreviaImg(id_usuario, id) {
        let credenciales = await this.listarCredencialesOneDrive(id_usuario);

        var response = await axios.post("api/Usuarios/ObtenerNuevoToken", {
            refresh_token: this.getLlave("refresh_token", credenciales).valor,
            redirect_uri: process.env.VUE_APP_URL_REDIRECTION,
        });

        let header = { Authorization: "Bearer " + response.data.access_token };
        let configuracion = { headers: header };

        let result = await axios
            .get(
                "https://graph.microsoft.com/v1.0/me/drive/items/" + id + "/thumbnails",
                configuracion
            )

        return result.data.value[0].large.url;
    },
    async vistaPreviaFile(id_usuario, id) {
        let credenciales = await this.listarCredencialesOneDrive(id_usuario);

        var response = await axios.post("api/Usuarios/ObtenerNuevoToken", {
            refresh_token: this.getLlave("refresh_token", credenciales).valor,
            redirect_uri: process.env.VUE_APP_URL_REDIRECTION,
        });

        let header = { Authorization: "Bearer " + response.data.access_token };
        let configuracion = { headers: header };

        let result = await axios
            .get(
                "https://graph.microsoft.com/v1.0/me/drive/items/" + id,
                configuracion
            )

        return result;
    },
    async linkPermiso(id_usuario, id) {
        let credenciales = await this.listarCredencialesOneDrive(id_usuario);

        var response = await axios.post("api/Usuarios/ObtenerNuevoToken", {
            refresh_token: this.getLlave("refresh_token", credenciales).valor,
            redirect_uri: process.env.VUE_APP_URL_REDIRECTION,
        });

        let header = { Authorization: "Bearer " + response.data.access_token };
        let configuracion = { headers: header };

        let result = await axios.post("https://graph.microsoft.com/v1.0/me/drive/items/" + id + "/createLink", {
            type: "view",
            scope: "anonymous"
        }, configuracion);

        return result;
    },
    async listarCredencialesOneDrive(id_usuario) {
        const credenciales = await axios.get(
            "api/DriveLlaves/Listar/" + id_usuario
        );
        return credenciales.data;
    },
    desencriptarDato(data) {
        var CryptoJS = require("crypto-js");
        var bytes = CryptoJS.AES.decrypt(data, "R3gi0n@l_2@22");
        return bytes.toString(CryptoJS.enc.Utf8);
    },
    getLlave(clave, credenciales = []) {
        for (var i = 0; i < credenciales.length; i++) {
            if (credenciales[i]["clave"] == clave) {
                return credenciales[i];
            }
        }
    },
    async eliminarArchivo(id_usuario, id) {
        let credenciales = await this.listarCredencialesOneDrive(id_usuario);

        var response = await axios.post("api/Usuarios/ObtenerNuevoToken", {
            refresh_token: this.getLlave("refresh_token", credenciales).valor,
            redirect_uri: process.env.VUE_APP_URL_REDIRECTION,
        });

        let header = { Authorization: "Bearer " + response.data.access_token };
        let configuracion = { headers: header };

        let result = await axios.delete("https://graph.microsoft.com/v1.0/me/drive/items/" + id, configuracion)
            .then((response) => {
                return response.status;
            }).catch((error) => {
                return "No se elimino"
            })
        return result;
    }
}